import {
  Divider as SemanticDivider,
  Form,
  Icon,
} from 'semantic-ui-react';

import styled from 'styled-components';

import {
  Button as ButtonLayoutComponent,
  Segment as SegmentLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  margin-left: auto;
  margin-right: auto;
  max-width: 400px;
`;

const Logo = styled.img`
  margin-bottom: 40px;
  margin-top: 75px;
  max-width: 200px;
`;

const Segment = styled(SegmentLayoutComponent)`
  width: 100%;

  &.ui.segment {
    padding: 30px 20px 20px 20px;
  }
`;

const Title = styled(TextLayoutComponent.Title)`
  color: ${(props) => props.theme.color.textSignScreen};
  font-size: 18px;
  margin-bottom: 40px;
  text-align: center;
  width: 100%;
`;

const ContainerName = styled.div`
  display: flex;

  .ui.form .field .ui.input input, .ui.input input {
    width: 100% !important;
  }
`;

const ContainerFirstName = styled.div`
  padding-right: 5px;
`;

const ContainerLastName = styled.div`
  padding-left: 5px;
`;

const Checkbox = styled(Form.Checkbox)`
  &.ui.checkbox, .ui.checkbox label {
    font-size: 12px;
  }
`;

const BottomContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  width: 100%;
`;

const Button = styled(ButtonLayoutComponent)`
  width: 100%;
`;

const Divider = styled(SemanticDivider)`
  &.ui.divider {
    border-top: 1px solid ${(props) => props.theme.color.divider};
    margin: 20px 0px;
    width: 100%;
  }
`;

const LinkedInIcon = styled(Icon).attrs(() => ({
  name: 'linkedin',
}))`
`;

const HaveAccount = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.textSignScreen};
  margin-top: 30px;
`;

const Error = styled.div`
  color: ${(props) => props.theme.color.textError};
  font-size: 12px;
  margin-bottom: 10px;
  margin-top: -10px;
`;

const ErrorName = styled.div`
  color: ${(props) => props.theme.color.textError};
  font-size: 12px;
  margin-top: -10px;
`;

const ErrorSubmit = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.textError};
  margin-top: 20px;
`;

const PrivacyPolicyContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  width: 100%;
`;

const PrivacyPolicy = styled(TextLayoutComponent.Muted)`
`;

export {
  BottomContainer,
  Button,
  Checkbox,
  Container,
  ContainerFirstName,
  ContainerLastName,
  ContainerName,
  Divider,
  Error,
  ErrorName,
  ErrorSubmit,
  HaveAccount,
  LinkedInIcon,
  Logo,
  PrivacyPolicy,
  PrivacyPolicyContainer,
  Segment,
  Title,
};
